"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stageLinks = void 0;
const production_1 = require("./production");
const ORIGIN = 'https://stage-m.place.naver.com';
const MYPLACE_WEB = 'https://stage-m.place.naver.com/my';
const BOOKING_GRAPHQL = 'https://stage-release-booking.io.naver.com/graphql';
const BOOKING_WEB_ORIGIN = 'https://stage-release-booking.io.naver.com';
/** https://oss.navercorp.com/Maps/sloop/wiki/Train-End-URLs-스펙/#host */
const TRAIN_TICKET_ORIGIN = 'https://stg-pt.map.naver.com/end-train';
exports.stageLinks = {
    ...production_1.productionLinks,
    BOOKING_GRAPHQL,
    MYPLACE_WEB,
    MYPLACE_API: 'https://stage-api.place.naver.com/my',
    MYPLACE_REVIEW_FEED: `${MYPLACE_WEB}/:userId/reviewfeed?reviewId=:reviewId`,
    API_URL_ON_BROWSER: 'https://stage-api.place.naver.com/my',
    API_URL_ON_NODE: 'http://profile-api-stage.myplace.svc.ar2.io.navercorp.com/my',
    FEDERATION_API_ON_BROWSER: 'https://bff-gateway.place.naver.com',
    FEDERATION_API_ON_NODE: 'https://place-federated-bff.io.naver.com',
    TRAIN_TICKET_CANCEL: `${TRAIN_TICKET_ORIGIN}/bridges/ticket/cancel/done?tNo=`,
    TRAIN_TICKET_DETAIL: `${TRAIN_TICKET_ORIGIN}/bridges/ticket/home?swNo=&sDt=&ssNo=&trPw=`,
    TRAIN_TICKET_MY_RESERVATION_LIST: `${TRAIN_TICKET_ORIGIN}/bridges/schedule-board/web/home?ac=ticket&userQuery=where%3Amo_fusion%2Cmenu%3Amap_tts-resercation%22`,
    TRAIN_TICKET_RESERVATION: `${TRAIN_TICKET_ORIGIN}/bridges/schedule-board/app/home`,
    BOOKING_MY: `${BOOKING_WEB_ORIGIN}/my/bookings?from=myp`,
    BOOKING_MY_COUPONS: `${BOOKING_WEB_ORIGIN}/my/coupons?from=myp`,
    BOOKING_BUSINESS_HOME: `${BOOKING_WEB_ORIGIN}/booking/bizes/:businessId?from=myp`,
    BOOKING_DETAIL: `${BOOKING_WEB_ORIGIN}/my/bookings/:bookingId?from=myp`,
    /** 예약상품 URL - businessTypeId 조회 불가능한 경우 redirection URL (businessTypeId 임의값) */
    BOOKING_ITEM_REDIRECT: `${BOOKING_WEB_ORIGIN}/booking/000/bizes/:businessId/items/:bizItemId?from=myp`,
    /** 예약상품 URL - businessTypeId 조회가능한 경우 사용 */
    BOOKING_ITEM: `${BOOKING_WEB_ORIGIN}/booking/:businessTypeId/bizes/:businessId/items/:bizItemId?from=myp`,
    ORDER_ITEM: `${BOOKING_WEB_ORIGIN}/order/bizes/:businessId/items/:bizItemId?theme=place&from=myp`,
    ORDER_MY: `${BOOKING_WEB_ORIGIN}/my/orders?from=myp`,
    ORDER_DETAIL: `${BOOKING_WEB_ORIGIN}/my/orders/:orderId?from=myp`,
    QUEUE_MY: `${BOOKING_WEB_ORIGIN}/my/queues?from=myp`,
    FILE_API: 'https://stage-files.place.naver.com/my',
    FILE_UPLOAD: 'https://stage-files.place.naver.com/my/upload',
    TRAVEL_HOTEL_REVIEW: `https://stage-hotels.naver.com/hotels/:hotelId/cpReview/myplace`,
    TRAVEL_HOTEL_DETAIL: `https://stage-hotels.naver.com/hotels/:hotelId`,
    TRAVEL_HOTEL_MY: `https://stage-travel.naver.com/my/reviews/me/hotel`,
    TRAVEL_HOTEL_MY_BOOKING: `https://stage-travel.naver.com/my/bookings/hotels`,
    MY_HOME: `${ORIGIN}/my`,
    ORIGIN,
    PLACE_DETAIL: `${ORIGIN}/place/:placeId`,
    TERMS: `${ORIGIN}/my/terms`,
    YEAR_END_2022: `${ORIGIN}/my/year-end/2022`,
};
